import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  TextField,
  Typography,
  Container,
  Box,
  Alert,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from '@mui/material';

const apiUrl = process.env.REACT_APP_API_URL;

const OwnerRegistration = () => {
  const { t, i18n } = useTranslation();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [userId, setUserId] = useState(''); // لتخزين user_id
  const [users, setUsers] = useState([]); // قائمة المستخدمين
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${apiUrl}/users`);
        setUsers(response.data);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    fetchUsers();
  }, []);

  const validateFields = () => {
    if (!firstName) {
      setError(t('please_fill_first_name'));
      return false;
    }
    if (!lastName) {
      setError(t('please_fill_last_name'));
      return false;
    }
    if (!phone) {
      setError(t('please_fill_phone')); // التأكد من أن رقم الجوال مملوء
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateFields()) {
      return;
    }

    try {
      const response = await axios.post(`${apiUrl}/owners`, {
        first_name: firstName,
        last_name: lastName,
        phone,
        email,
        address,
        user_id: userId, // استخدام userId بدلاً من selectedUser
      });
      console.log(response); // استخدم response بطريقة ما، مثل طباعته في وحدة التحكم
      setSuccess(t('owner_registered_successfully'));
      resetForm();
      navigate('/owner-list');
    } catch (error) {
      setError(t('error_registering_owner'));
    }
  };

  const resetForm = () => {
    setFirstName('');
    setLastName('');
    setPhone('');
    setEmail('');
    setAddress('');
    setUserId('');
    setError('');
    setSuccess('');
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
        dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
      >
        <Typography component="h1" variant="h5">
          {t('register_owner')}
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="firstName"
            label={t('first_name')}
            name="firstName"
            autoComplete="firstName"
            autoFocus
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="lastName"
            label={t('last_name')}
            name="lastName"
            autoComplete="lastName"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="phone"
            label={t('phone')}
            name="phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <TextField
            margin="normal"
            fullWidth
            id="email"
            label={t('email')}
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            margin="normal"
            fullWidth
            id="address"
            label={t('address')}
            name="address"
            multiline
            rows={4}
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
          <FormControl fullWidth margin="normal">
            <InputLabel>{t('select_user')}</InputLabel>
            <Select value={userId} onChange={(e) => setUserId(e.target.value)}>
              {users.map((user) => (
                <MenuItem key={user.user_id} value={user.user_id}>
                  {user.first_name} {user.last_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              mt: 3,
              mb: 2,
            }}
          >
            <Button type="submit" variant="contained" sx={{ width: '48%' }}>
              {t('register_owner')}
            </Button>

            <Button
              variant="outlined"
              color="secondary"
              onClick={() => navigate('/owner-list')} // استبدل '/owner-list' بالمسار المناسب لزر الإلغاء
              sx={{ width: '48%' }}
            >
              {t('cancel')}
            </Button>
          </Box>

          {error && <Alert severity="error">{error}</Alert>}
          {success && <Alert severity="success">{success}</Alert>}
        </Box>
      </Box>
    </Container>
  );
};

export default OwnerRegistration;
